<mat-chip-listbox multiple class="small">
    <mat-chip-option class="v2-mat-mdc-chip" color="primary" selected>chip
        <button matChipRemove>
            <mat-icon [svgIcon]="'times'"></mat-icon>
        </button>
    </mat-chip-option>
    <mat-chip-option class="v2-mat-mdc-chip" color="accent" selected>chip</mat-chip-option>
    <mat-chip-option class="v2-mat-mdc-chip" color="warn" selected>chip</mat-chip-option>
    <mat-chip-option class="v2-mat-mdc-chip" disabled>chip</mat-chip-option>
    <mat-chip-option class="v2-mat-mdc-chip chip-neutral" selected>chip</mat-chip-option>
</mat-chip-listbox>

<mat-chip-listbox multiple>
    <mat-chip-option class="v2-mat-mdc-chip" color="primary" selected>
        chip <button matChipRemove>
            <mat-icon [svgIcon]="'times'"></mat-icon>
        </button></mat-chip-option>
    <mat-chip-option class="v2-mat-mdc-chip" color="accent" selected>chip</mat-chip-option>
    <mat-chip-option class="v2-mat-mdc-chip" color="warn" selected>chip</mat-chip-option>
    <mat-chip-option class="v2-mat-mdc-chip" disabled>chip</mat-chip-option>
    <mat-chip-option class="v2-mat-mdc-chip chip-neutral" selected>chip</mat-chip-option>
</mat-chip-listbox>

<mat-chip-listbox multiple>
    <mat-chip-option class="v2-mat-mdc-chip bold" color="primary" selected>
        chip <button matChipRemove>
            <mat-icon [svgIcon]="'times'"></mat-icon>
        </button></mat-chip-option>
    <mat-chip-option class="v2-mat-mdc-chip bold" color="accent" selected>chip</mat-chip-option>
    <mat-chip-option class="v2-mat-mdc-chip bold" color="warn" selected>chip</mat-chip-option>
    <mat-chip-option class="v2-mat-mdc-chip bold" disabled>chip</mat-chip-option>
    <mat-chip-option class="v2-mat-mdc-chip bold chip-neutral" selected>chip</mat-chip-option>
</mat-chip-listbox>

<mat-chip-listbox multiple class="large">
    <mat-chip-option class="v2-mat-mdc-chip" color="primary" selected>
        chip <button matChipRemove>
            <mat-icon [svgIcon]="'times'"></mat-icon>
        </button></mat-chip-option>
    <mat-chip-option class="v2-mat-mdc-chip" color="accent" selected>chip</mat-chip-option>
    <mat-chip-option class="v2-mat-mdc-chip" color="warn" selected>chip</mat-chip-option>
    <mat-chip-option class="v2-mat-mdc-chip" disabled>chip</mat-chip-option>
    <mat-chip-option class="v2-mat-mdc-chip chip-neutral" selected>chip</mat-chip-option>
</mat-chip-listbox>